/**
 * lineQuantity.js: the ONE reader of a quote line's quantity (IDI-536).
 *
 * `lineSqFt` is the Quote Items Sq Ft reader that lived inline in JobDetail
 * (IDI-40): writers emit the unit as 'sqft' / 'sq ft' (and some items carry an
 * explicit `sqft` value with NO unit field at all). Normalise the unit (strip
 * spaces/underscores, lowercase) and also honour an explicit sqft field.
 *
 * The Create Work Order sheet's line list reads the same value, so a 300 sq ft
 * line reads 300 there too. Unknown quantity is "—", never "Qty: 0".
 */

/** The line's sq ft, or null when the line is not measured in sq ft. */
export function lineSqFt(item) {
  if (!item || typeof item !== 'object') return null;
  const unitNorm = String(item.unit || item.unitOfMeasure || '')
    .replace(/[\s_]/g, '').toLowerCase();
  const explicitSqFt = item.sqft ?? item.sqFt ?? item.sq_ft;
  const isSqFt = unitNorm === 'sqft' || explicitSqFt != null;
  return explicitSqFt ?? (isSqFt ? (item.quantity ?? item.qty ?? null) : null);
}

/** The line's quantity: its sq ft through the reader above, else quantity/qty; null when unknown. */
export function lineQuantity(item) {
  if (!item || typeof item !== 'object') return null;
  const raw = lineSqFt(item) ?? item.quantity ?? item.qty;
  if (raw == null || String(raw).trim() === '') return null;
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : null;
}

/** Display text for a line's quantity: the number, or "—" when unknown. */
export function lineQuantityText(item) {
  const n = lineQuantity(item);
  return n == null ? '\u2014' : String(n);
}
